import type { ShortcutActionDefinition } from 'src/stores/shortcuts/types';

export const SHORTCUT_ACTIONS: ReadonlyArray<ShortcutActionDefinition> = [
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-magnifying-glass',
		id: 'app.spotlight.toggle',
		labelI18nKey: 'shortcuts_action_spotlight_toggle',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-gear',
		id: 'app.settings.open',
		labelI18nKey: 'shortcuts_action_settings_open',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-keyboard',
		id: 'app.cheatsheet.toggle',
		labelI18nKey: 'shortcuts_action_cheatsheet_toggle',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-moon',
		id: 'app.darkmode.toggle',
		labelI18nKey: 'shortcuts_action_darkmode_toggle',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-sidebar',
		id: 'app.sidebar.toggle',
		labelI18nKey: 'shortcuts_action_sidebar_toggle',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-pen-to-square',
		id: 'app.create.note',
		labelI18nKey: 'shortcuts_action_create_note',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-square-check',
		id: 'app.create.task',
		labelI18nKey: 'shortcuts_action_create_task',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-envelope',
		id: 'app.create.mail',
		labelI18nKey: 'shortcuts_action_create_mail',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-phone',
		id: 'app.create.phonecall',
		labelI18nKey: 'shortcuts_action_create_phonecall',
	},
	{
		category: 'global',
		contexts: ['global'],
		icon: 'fa-calendar',
		id: 'app.create.appointment',
		labelI18nKey: 'shortcuts_action_create_appointment',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-house',
		id: 'nav.inbox',
		labelI18nKey: 'shortcuts_action_nav_inbox',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-square-check',
		id: 'nav.tasks',
		labelI18nKey: 'shortcuts_action_nav_tasks',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-envelope',
		id: 'nav.mails',
		labelI18nKey: 'shortcuts_action_nav_mails',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-pen-to-square',
		id: 'nav.notes',
		labelI18nKey: 'shortcuts_action_nav_notes',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-calendar-days',
		id: 'nav.calendar',
		labelI18nKey: 'shortcuts_action_nav_calendar',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-phone',
		id: 'nav.phonecalls',
		labelI18nKey: 'shortcuts_action_nav_phonecalls',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-file-lines',
		id: 'nav.documents',
		labelI18nKey: 'shortcuts_action_nav_documents',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-comment-alt',
		id: 'nav.messages',
		labelI18nKey: 'shortcuts_action_nav_messages',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-chart-kanban',
		id: 'nav.kanban',
		labelI18nKey: 'shortcuts_action_nav_kanban',
	},
	{
		category: 'navigation',
		contexts: ['global'],
		icon: 'fa-gear',
		id: 'nav.settings',
		labelI18nKey: 'shortcuts_action_nav_settings',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-arrow-down',
		id: 'list.item.next',
		labelI18nKey: 'shortcuts_action_list_item_next',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-arrow-up',
		id: 'list.item.prev',
		labelI18nKey: 'shortcuts_action_list_item_prev',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-star',
		id: 'list.favorite.toggle',
		labelI18nKey: 'shortcuts_action_list_favorite_toggle',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-list',
		id: 'list.tab.all',
		labelI18nKey: 'shortcuts_action_list_tab_all',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-user',
		id: 'list.tab.mine',
		labelI18nKey: 'shortcuts_action_list_tab_mine',
	},
	{
		category: 'list',
		contexts: ['list'],
		icon: 'fa-circle-half-stroke',
		id: 'list.tab.open',
		labelI18nKey: 'shortcuts_action_list_tab_open',
	},
	{
		category: 'detail',
		contexts: ['detail:mail'],
		icon: 'fa-reply',
		id: 'mail.reply',
		labelI18nKey: 'shortcuts_action_mail_reply',
	},
	{
		category: 'detail',
		contexts: ['detail:mail'],
		icon: 'fa-reply-all',
		id: 'mail.reply_all',
		labelI18nKey: 'shortcuts_action_mail_reply_all',
	},
	{
		category: 'detail',
		contexts: ['detail:mail'],
		icon: 'fa-forward',
		id: 'mail.forward',
		labelI18nKey: 'shortcuts_action_mail_forward',
	},
	{
		category: 'detail',
		contexts: ['detail:mail'],
		destructive: true,
		icon: 'fa-bug',
		id: 'mail.spam',
		labelI18nKey: 'shortcuts_action_mail_spam',
	},
	{
		category: 'detail',
		contexts: ['detail:task'],
		icon: 'fa-calendar-plus',
		id: 'task.delay_day',
		labelI18nKey: 'shortcuts_action_task_delay_day',
	},
	{
		category: 'detail',
		contexts: ['detail:task'],
		icon: 'fa-calendar-week',
		id: 'task.delay_week',
		labelI18nKey: 'shortcuts_action_task_delay_week',
	},
	{
		allowInEditor: true,
		category: 'detail',
		contexts: ['detail:task', 'detail:note'],
		icon: 'fa-save',
		id: 'detail.save',
		labelI18nKey: 'shortcuts_action_detail_save',
	},
	{
		category: 'detail',
		contexts: ['detail:task', 'detail:note', 'detail:mail'],
		icon: 'fa-arrow-up-from-bracket',
		id: 'detail.share',
		labelI18nKey: 'shortcuts_action_detail_share',
	},
	{
		category: 'detail',
		contexts: ['detail:task', 'detail:note', 'detail:mail'],
		destructive: true,
		icon: 'fa-trash',
		id: 'detail.delete',
		labelI18nKey: 'shortcuts_action_detail_delete',
	},
	{
		allowInEditor: true,
		category: 'detail',
		contexts: ['create:mail'],
		icon: 'fa-paper-plane',
		id: 'mail.create.send',
		labelI18nKey: 'shortcuts_action_mail_create_send',
	},
	{
		allowInEditor: true,
		category: 'detail',
		contexts: ['create:mail'],
		icon: 'fa-clock',
		id: 'mail.create.send_later',
		labelI18nKey: 'shortcuts_action_mail_create_send_later',
	},
];

export const SHORTCUT_ACTIONS_BY_ID: Readonly<Record<string, ShortcutActionDefinition>> = SHORTCUT_ACTIONS.reduce<
	Record<string, ShortcutActionDefinition>
>((accumulator, action) => {
	accumulator[action.id] = action;
	return accumulator;
}, {});
